import React, { useContext } from 'react';
import { CategoryInsightsSettingsContextProvider } from 'contexts/CategoryInsightsSettingsContext/CategoryInsightsContextProvider';
import { FragmentedCategoriesProvider } from 'contexts/CategoryInsightsKpi/FragmentedCategoriesProvider';
import { WellManagedCategoriesProvider } from 'contexts/CategoryInsightsKpi/WellManagedCategoriesProvider';
import { SignificantYoyGrowthProvider } from 'contexts/CategoryInsightsKpi/SignificantYoyGrowthProvider';
import { CommonVendorsProvider } from 'contexts/CategoryInsightsKpi/CommonVendorsProvider';
import { OutofPolicySpendProvider } from 'contexts/CategoryInsightsKpi/OutofPolicySpendProvider';
import { NonPreferedSuppliersProvider } from 'contexts/CategoryInsightsKpi/NonPreferedSuppliersProvider';
import { IncreasedMonthlyPCardProvider } from 'contexts/CategoryInsightsKpi/IncreasedMonthlyPCardProvider';
import { PaymentTermsProvider } from 'contexts/CategoryInsightsKpi/PaymentTermsProvider';
import { SupplierSegmentationProvider } from 'contexts/CategoryInsightsKpi/SupplierSegmentationProvider';
import { CategorySpendBenchmarkProvider } from 'contexts/CategorySpendBenchmark/CategorySpendBenchmarkProvider';
import { CategoryRevenueBenchmarkProvider } from 'contexts/CategoryRevenueBenchmark/CategoryRevenueBenchmarkProvider';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { getCurrencySymbolFromOptions } from 'CategoryManagement/utils';
import { SettingsContext } from 'contexts/SettingsContext';
import { CommonSupplierProvider } from 'contexts/CategoryInsightsKpi/CommonSupplierProvider';
/**
 * withCategoryManagementProviders HOC Component
 * @param {JSX} WrappedComponent - Accepts a component and gives a Wrapped componets with Context Providers
 */

// Higher Order Component (HOC) that wraps a component with multiple providers
const withCategoryManagementInsightsProviders = WrappedComponent => {
	// Return a new component with added context providers
	return function CategoryManagementWrapper(props) {
		const {
			options: { currency: currencyList },
		} = useContext(SettingsOptionsContext);
		const { currency } = useContext(QueryStringContext);
		const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
		const { hideDecimals } = useContext(SettingsContext);
		return (
			<>
				<CategoryInsightsSettingsContextProvider>
					<FragmentedCategoriesProvider
						currencySymbol={currencySymbol}
						hideDecimals={hideDecimals}
					>
						<WellManagedCategoriesProvider
							currencySymbol={currencySymbol}
							hideDecimals={hideDecimals}
						>
							<SignificantYoyGrowthProvider>
								<CommonVendorsProvider>
									<OutofPolicySpendProvider
										currencySymbol={currencySymbol}
										hideDecimals={hideDecimals}
									>
										<NonPreferedSuppliersProvider>
											<IncreasedMonthlyPCardProvider>
												<PaymentTermsProvider
													currencySymbol={currencySymbol}
													hideDecimals={hideDecimals}
												>
													<SupplierSegmentationProvider>
														<CategorySpendBenchmarkProvider>
															<CategoryRevenueBenchmarkProvider>
																<CommonSupplierProvider
																	currencySymbol={currencySymbol}
																	hideDecimals={hideDecimals}
																>
																	<WrappedComponent {...props} />
																</CommonSupplierProvider>
															</CategoryRevenueBenchmarkProvider>
														</CategorySpendBenchmarkProvider>
													</SupplierSegmentationProvider>
												</PaymentTermsProvider>
											</IncreasedMonthlyPCardProvider>
										</NonPreferedSuppliersProvider>
									</OutofPolicySpendProvider>
								</CommonVendorsProvider>
							</SignificantYoyGrowthProvider>
						</WellManagedCategoriesProvider>
					</FragmentedCategoriesProvider>
				</CategoryInsightsSettingsContextProvider>
			</>
		);
	};
};

export default withCategoryManagementInsightsProviders;
